import React from 'react'

/** Lays out accepted-pass cards in as many columns as the surrounding panel fits. */
export function AcceptedPassGrid({children}: {children: React.ReactNode}) {
    return (
        <div className="@container">
            <ul className="grid grid-cols-2 items-stretch gap-2 @min-[640px]:grid-cols-3 @min-[900px]:grid-cols-4 sm:gap-3">
                {children}
            </ul>
        </div>
    )
}

/** A compact pass card in its class colour, e.g. one of the passes a class accepts. */
export function AcceptedPassCard({name, meta, price, logo, indicator, backgroundColor}: {
    name: React.ReactNode
    /** Entries and validity, under the name. */
    meta?: React.ReactNode
    price?: React.ReactNode
    logo?: React.ReactNode
    indicator?: React.ReactNode
    backgroundColor: string
}) {
    return (
        <div
            data-testid="client-surface-card"
            className="@container relative h-full overflow-hidden rounded-lg border border-[rgba(15,23,42,0.08)] dark:border-white/10"
            style={{backgroundColor}}
        >
            <div className="flex h-full flex-col p-3">
                <div className="flex items-start justify-between gap-2">
                    <h3 className="text-base font-semibold leading-6 text-slate-800 [overflow-wrap:anywhere]">{name}</h3>
                    {indicator}
                </div>
                {meta ? <p className="mt-0.5 text-sm leading-5 text-slate-600">{meta}</p> : null}
                {price || logo ? (
                    // The price group sits on the card's bottom edge, so prices line up across a row whatever the name length.
                    <div className="mt-auto flex flex-wrap items-end justify-between gap-2 pt-3">
                        {price}
                        {logo}
                    </div>
                ) : null}
            </div>
        </div>
    )
}
